import React from "react";
import "./title-box.scss";

export default ({ title }) => {
    return (
        <div className={'title-box'} >{title}</div>
    );
};
